import React from 'react'
import styled from 'styled-components'

import Card from '@/components/card'
import FeatureBlock from '@/components/feature-block'
import type {LegalPageThirdPartyLicencesQuery} from '@/graphql-types'
import handleNoPrismicData from '@/utils/handle-no-prismic-data'
import {tokens} from '@helios/../packages/ui/theme'
import RichText from '@helios/shared/components/rich-text'
import {useGlobalStrings} from '@helios/shared/providers/global-strings'
import {Section, BackgroundWrapper, Layout, TitleLayout} from '@helios/shared/styles/grid'
import hasNonEmptyItems from '@helios/shared/utils/has-non-empty-items'

interface Props {
    content: LegalPageThirdPartyLicencesQuery['allPrismicLegalPageThirdPartyLicences']['nodes'][number]['data']
}

const LegalThirdPartyLicencesContent = ({content}: Props) => {
    const {visit_website} = useGlobalStrings()

    if (!content) {
        return handleNoPrismicData()
    }

    return (
        <>
            {hasNonEmptyItems(content.sections) &&
                content.sections.map((thirdPartySection, i) => {
                    return (
                        <Section key={`${thirdPartySection.section_title}-${i}`}>
                            <FeatureBlock
                                title={thirdPartySection.section_title}
                                image={thirdPartySection.section_image}
                                mirrored={thirdPartySection.inverse}
                            >
                                <RichText content={thirdPartySection.section_content.richText} />
                            </FeatureBlock>
                        </Section>
                    )
                })}
            <BackgroundWrapper color="muted">
                <SpacedSection>
                    <TitleLayout>
                        <RichText variant="title-base" content={content.recognition_title} />
                    </TitleLayout>
                    <Layout variant="four-equal" alignItems="stretch">
                        {content.predefined_licences.document.data.licences.map(
                            (recognitionItem, i) => (
                                <Card
                                    {...recognitionItem}
                                    key={`${recognitionItem.program_name}-${i}`}
                                    title={recognitionItem.licence_type}
                                    body={recognitionItem.program_name}
                                    ctaText={visit_website}
                                    ctaLink={recognitionItem.program_url}
                                />
                            )
                        )}
                    </Layout>
                </SpacedSection>
            </BackgroundWrapper>
        </>
    )
}

const SpacedSection = styled(Section)`
    display: grid;
    row-gap: ${tokens.spacing40};
`

export default LegalThirdPartyLicencesContent
